
import { GalleryPhoto } from "@/components/gallery/carousel/types";
import { generateStandardGalleryPdf } from "./generators/standardGalleryGenerator";
import { generatePregnancyGalleryPdf } from "./generators/pregnancyGalleryGenerator";
import { PdfExportOptions } from "./types";

/**
 * Generates a PDF document with gallery photos
 */
export const generateGalleryPdf = async (
  photos: GalleryPhoto[],
  collectionTitle: string | undefined,
  options: PdfExportOptions
): Promise<string> => {
  if (photos.length === 0) return "";
  
  try {
    // Check if this is a pregnancy collection
    const isPregnancyCollection = collectionTitle?.toLowerCase().includes('pregnancy');
    
    // Use appropriate generator based on collection type
    if (isPregnancyCollection && photos.length > 0) {
      return await generatePregnancyGalleryPdf(photos, collectionTitle, options);
    } else {
      return await generateStandardGalleryPdf(photos, collectionTitle, options);
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  }
};
